import React, { useContext } from 'react';
import { IEditDishContext, EditDishContext } from '../../../editDishState/editDishContext';
import { MenuTranslationForm } from 'components/TranslationForm/MenuTranslationForm';

interface ITranslationsForm {
	isVisible: boolean;
}

const TranslationsForm: React.FC<ITranslationsForm> = ({ isVisible }) => {
	const {
		setDefaultCustomerLanguage,
		setTranslationTab,
		changeNameTranslation,
		changeDescriptionTranslation,
		selectedCustomer,
		translations,
		selectedTranslationTab,
	} = useContext<IEditDishContext>(EditDishContext);
	return (
		<MenuTranslationForm
			setDefaultCustomerLanguage={setDefaultCustomerLanguage}
			setTranslationTab={setTranslationTab}
			changeNameTranslation={changeNameTranslation}
			changeDescriptionTranslation={changeDescriptionTranslation}
			isVisible={isVisible}
			IDSelectedCustomer={selectedCustomer}
			translations={translations}
			selectedTranslationTab={selectedTranslationTab}
		/>
	);
};

export default TranslationsForm;
